import React from 'react';

const ImageLink = ({ tab, image, alt, text, toggle }) => {
  return (
    <div className="nav-link" style={{ cursor: 'pointer' }} onClick={() => toggle(tab)}>
      <span className="circle">
        <img src={require(`../dataSource/img/${image}`)} width="18" height="18" alt={alt} />
      </span>
      &nbsp;{text}
    </div>
  );
};

export default ImageLink;
